import type { DriverBalance } from '@chukua/common';
import { Alert } from 'antd';
import { formatMoney } from '../../../shared/policies/format-money';

/** What the driver still owes from earlier trips, so a dispatcher sees it before giving another advance. A warning, never a block. */
export function DispatchCarryForward({ driverName, owes }: { driverName: string; owes: DriverBalance[] }) {
  if (owes.length === 0) return null;
  const amounts = owes.map(formatMoney).join(' and ');
  return <Alert type="warning" showIcon title={`${driverName} still owes the company ${amounts} from earlier trips`} />;
}
